import { MatPaginatorIntl } from '@angular/material/paginator';

const rangeLabel = (page: number, pageSize: number, length: number) => {
  const totalPage = Math.ceil(length / pageSize);
  return `Page ${page + 1} of ${totalPage}`;
};

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getCustomPaginator(): any {
  const paginatorIntl = new MatPaginatorIntl();
  paginatorIntl.getRangeLabel = rangeLabel;

  return paginatorIntl;
}
